import * as Base from './base.js'
import * as Device from './device.js'
import * as Ota from './ota.js'
import * as P26001 from './p26001.js'
import * as P26003 from './p26003.js'
import * as P26004 from './p26004.js'
import * as P26005 from './p26005.js'
import * as P26006 from './p26006.js'
import * as P26007 from './p26007.js'

const Filter = {
    ...Base,
    ...Device,
    ...Ota,
    ...P26001,
    ...P26003,
    ...P26004,
    ...P26005,
    ...P26006,
    ...P26007,
}
export default Filter
